import {
  GET_PROCESSOS,
  GET_PROCESSOS_FAIL,
  GET_PROCESSOS_SUCCESS,
  GET_PROCESSO_COMPLETO,
  UPDATE_PROCESSO,
  UPDATE_PROCESSO_SUCCESS,
  UPDATE_PROCESSO_FAIL,
  POST_PROCESSO_SUCCESS,
  POST_PROCESSO_MSG,
  RESET_PROCCESS_MESSAGES
} from "./actionTypes"

export const getProcessos = () => ({
  type: GET_PROCESSOS,
})

export const getProcessosSuccess = processos => ({
  type: GET_PROCESSOS_SUCCESS,
  payload: processos,
})

export const getProcessosFail = error => ({
  type: GET_PROCESSOS_FAIL,
  payload: error,
})

export const getProcessoCompleto = processoId => ({
  type: GET_PROCESSO_COMPLETO,
  processoId,
})

export const updateProcesso = processo => ({
  type: UPDATE_PROCESSO,
  payload: processo,
})

export const updateProcessoSuccess = processo => ({
  type: UPDATE_PROCESSO_SUCCESS,
  payload: processo,
})

export const updateProcessoFail = error => ({
  type: UPDATE_PROCESSO_FAIL,
  payload: error,
})

export const postProcessoSuccess = processos => ({
  type: POST_PROCESSO_SUCCESS,
  payload: processos
})

export const postProcessoMsg = response => ({
  type: POST_PROCESSO_MSG,
  payload: response
})

export const resetProccessMessages = () => {
  return {
    type: RESET_PROCCESS_MESSAGES
  }
}